import { svg } from "lit";

export const programs = svg`
<svg width="36" height="23" viewBox="0 0 36 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.0556 1H1V21.4167H34.0556V1Z" stroke="#666666" stroke-width="1.94444"/>
<path d="M21.4167 4.88892H4.88892V12.6667H21.4167V4.88892Z" fill="#666666"/>
<path d="M30.1667 14.6111H4.88892V17.5278H30.1667V14.6111Z" fill="#666666"/>
<path d="M30.1666 4.88892H23.3611V12.6667H30.1666V4.88892Z" fill="#666666"/>
</svg>
`;